import styled from 'styled-components'

export default styled.label`
  display: block;
  user-select: none;
  letter-spacing: .5px;
  margin-bottom: 8px;
  font-weight: 600;
  color: #b9bbbe;
  text-transform: uppercase;
  line-height: 16px;
  font-size: 12px;
`
